export const BI_MODULE = 'BI';
export const TRACE_MODULE = 'TRACE';
